<template>
	<div class="indexbg">
		<topbar></topbar>
		<sortHeader></sortHeader>
		<div class="clear mt15"></div>
		<!--container 开始-->
		<div class="w1200 bc">
		    <!--购物车：开始-->
		    <div class="hq-shopping-cart">
		        <!--购物流程：开始-->
		        <div class="hq-reg-step">
		            <ul class="ico">
		                <li>
		                	<p class="item">购物车</p>
		                    <i class="step-count"></i>
		                </li>
		                <li><span class="line"></span></li>
		                <li>
		                	<p class="item">提交订单</p>
		                    <i class="step-count"></i>
		                </li>
		                <li><span class="line"></span></li>
		                <li>
		                	<p class="item">确认付款</p>
		                    <i class="step-count"></i>
		                </li>
		                <li><span class="line"></span></li>
		                <li class="active">
		                	<p class="item">下单成功</p>
		                    <i class="step-count"></i>
		                </li>
		            </ul>
		        </div>
		    <!--购物流程：结束-->
		    <!--提示：开始-->
		    <div class="tipsbox success">
		    	<i class="icon"></i>
		    	<h3>支付申请成功！</h3>
		        <p class="text">说明：您的支付申请已受理，请查看是否扣费。</p>
		        <div class="ft">
		        	<a class="btn"v-on:click="viewAllOrders()">查看全部订单</a>
		            <a class="btn" href="#">返回首页</a>
		        </div>
		    </div>
		    <!--提示：结束-->
		    </div>
		    <!--购物车：结束-->
			<div class="clear"></div>
		    <div class="mb20 ad-4 mt20"><img src="../../../static/images/footer-ad-1.png" width="1200" height="60"></div>
		</div>
		<!--container 结束-->

		<div class="clear"></div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>

	</div>
</template>

<script>
	/*引入Vue框架*/
	import Vue from 'vue'
	/*引入资源请求插件*/
	import VueResource from 'vue-resource'
	/*使用VueResource插件*/
	Vue.use(VueResource)
	import TopBar from '@/components/TopBar'
	import Header from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import FooterCopyright from '@/components/FooterCopyright'
	//import jQuery from "../../../static/js/jquery.min.js"
	import jQuery from 'jquery';
	import {getImgUrl,dateFormat,getValueFromMap,showMoney,parseResult,getCmsUrl,getAboutUsUrl,getEmallUrl} from "../../../static/js/emallUtils.js"
	export default {
	  name: 'paySuccess',
	  data () {
	    return {
	    }
	  },
	  components:{
					'sortHeader':Header,
					'footermenu':FooterMenu,
					'footercopyright':FooterCopyright
	  },
	  methods:{
	  	viewAllOrders: function() {
			window.location.href = getEmallUrl() + '/orderManage/myOrderList.htm';
		}
	  },
	   mounted(){
	    	window.scrollTo(0, 0);
			}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/pay/payComplete.vue?43a6f845